<template>
  <div class="playVideo-layout">
    <div v-if="showVideoBegin&&form.id&&form.status==0" class="before_T">
      Start in
      <span>{{videoBegin.d}}</span>Days<span>{{videoBegin.h}}</span>:<span>{{videoBegin.m}}</span>:<span>{{videoBegin.s}}</span>
    </div>
    <div class="playBox pofBox">
      <!-- 外链 -->
      <!-- 外链 -->
      <!-- 外链 -->
      <div v-if="2==1" class="playBack">
        <img width="100%" height="100%" :src="form.cover_path" alt="">
        <div class="other">
          <a-button type="primary">
            Click to play
          </a-button>
        </div>
      </div>

      <!-- 未开始 -->
      <!-- 未开始 -->
      <!-- 未开始 -->
      <div v-if="form.status==0" class="before playBack">
        <img width="100%" height="100%" :src="form.cover_path||meeting_data.head_img_path" alt="">
        <!-- <div class="txt">{{endTime}}</div> -->
      </div>

      <!-- 直播中 -->
      <!-- 直播中 -->
      <!-- 直播中 -->
      <div v-show="form.status==1&&form.live_link||form.status==2&&form.back_link&&form.is_show_back" class="begin playBack">
        <!-- m3u8播放器直播 -->
        <div v-show="videoType&&form.status==1" id="app-container" class="video-box videoBox">
          <video controls playsinline ref="videoElement" :src="form.live_link" :poster="form.cover_path"
            id="videoElement" style="width: 100%; height: 100%; object-fit: fill">
          </video>
          <!-- <div @click="playVideo('videoElement')" class="video_play_btn"></div> -->
        </div>
        <!-- m3u8播放器历史 -->
        <div v-show="videoType&&form.status==2" id="app-container" class="video-box videoBox">
          <video controls playsinline ref="videoElement2" :src="form.back_link" :poster="form.cover_path"
            id="videoElement2" style="width: 100%; height: 100%; object-fit: fill"></video>
          <!-- <div @click="playVideo('videoElement2')" class="video_play_btn"></div> -->
        </div>

        <!-- mp4播放器 -->
        <div v-show="!videoType" class="videoBox">
          <video controls="controls" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow"
            x5-playsinline="true" v-show="form.status==1" :poster="form.cover_path" class="video"
            :src="form.live_link"></video>
          <video controls="controls" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow"
            x5-playsinline="true" v-show="form.status==2" :poster="form.cover_path" class="video"
            :src="form.back_link"></video>
        </div>
      </div>

      <!-- 直播已结束 -->
      <!-- 直播已结束 -->
      <!-- 直播已结束 -->
      <div v-show="form.status==2&&!form.is_show_back||form.status==2&&form.is_show_back&&!form.back_link"
        class="after playBack">
        <img width="100%" height="100%" :src="form.cover_path" alt="">
        <div v-show="!form.peroration" class="txt">The live broadcast has ended and the playback is being generated!
        </div>
        <div v-show="form.peroration" class="txt">{{form.peroration}}</div>
      </div>
    </div>
  </div>

</template>

<script>
import hlsjs from "hls.js";
export default {
  props: ['form', 'meeting_data'],
  name: "About",
  components: {},
  data() {
    return {
      timer: null,
      endTime: "",
      videoBegin: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      },
      showVideoBegin: false,
      VideoForm: {},
      videoType: "",
    };
  },
  created() {

  },
  mounted() {
    this.VideoForm = this.form

    if (this.VideoForm.status == 0) {
      return this.countDown()
    }


    if (this.VideoForm.status == 1 && this.VideoForm.live_link) {
      this.videoType = this.VideoForm.live_link.includes('m3u8');
      if (this.videoType) {
        return this.show();
      }
    }

    if (this.VideoForm.status == 2 && !this.VideoForm.is_show_back) {
      return;
    }

    if (this.VideoForm.status == 2 && this.VideoForm.back_link) {
      this.videoType = this.VideoForm.back_link.includes('m3u8');
      if (this.videoType) {
        return this.showHistory();
      }
    }


  },
  methods: {
    playVideo(id) {
      console.log(id);
      this.$refs[id].play();
      document.querySelectorAll(".video_play_btn")[0].style.display = "none";
    },
    //播放
    show() {
      this.video = this.$refs.videoElement; //定义挂载点
      console.log(this.video);
      if (hlsjs.isSupported()) {
        this.hlsjs = new hlsjs();
        this.hlsjs.loadSource(this.form.live_link); //设置播放路径
        this.hlsjs.attachMedia(this.video); //解析到video标签上
        console.log(this.hlsjs);
        this.hlsjs.on(hlsjs.Events.MANIFEST_PARSED, () => {
          this.video.play();
          this.video.play().muted(false);
          console.log("加载成功");
        });
        this.hlsjs.on(hlsjs.Events.ERROR, (event, data) => {
          //   console.log(event, data);
          // 监听出错事件
          console.log("加载失败");
        });
      } else {
        // this.$message.error("不支持的格式");
        return;
      }
    },
    //播放历史
    showHistory() {
      this.video = this.$refs.videoElement2; //定义挂载点
      console.log(this.video);
      if (hlsjs.isSupported()) {
        this.hlsjs = new hlsjs();
        this.hlsjs.loadSource(this.form.back_link); //设置播放路径
        this.hlsjs.attachMedia(this.video); //解析到video标签上
        console.log(this.hlsjs);
        this.hlsjs.on(hlsjs.Events.MANIFEST_PARSED, () => {
          this.video.play();
          console.log("加载成功");
        });
        this.hlsjs.on(hlsjs.Events.ERROR, (event, data) => {
          //   console.log(event, data);
          // 监听出错事件
          console.log("加载失败");
        });
      } else {
        // this.$message.error("不支持的格式");
        return;
      }
    },
    //停止播放
    closeVideo() {
      if (this.hlsjs) {
        this.$refs.videoElement.pause();
        this.video.pause();
        this.hlsjs.destroy();
        this.hlsjs = null;
        this.$emit("closeVideo");
      }
    },
    countDown() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      var _this = this;
      let countDown = 60 * 60;
      let endTime = this.VideoForm.begin_time * 1000;
      this.timer = setInterval(function () {
        let now = new Date();
        let diff = endTime - now;
        if (diff < 0) {
          _this.showVideoBegin = true;
          return _this.endTime = 'Please wait a moment...';
        }
        countDown = Math.floor(diff / 1000);

        console.log(Math.sign(countDown))
        var d = parseInt(countDown / 60 / 60 / 24);
        // d = d < 10 ? "0" + d : d;
        var h = parseInt((countDown / 60 / 60) % 24);
        h = h < 10 ? "0" + h : h;
        var m = parseInt((countDown / 60) % 60);
        m = m < 10 ? "0" + m : m;
        var s = parseInt(countDown % 60);
        s = s < 10 ? "0" + s : s;
        _this.videoBegin.d = d
        _this.videoBegin.h = h
        _this.videoBegin.m = m
        _this.videoBegin.s = s
        _this.showVideoBegin = true;
        _this.endTime =
          "Remaining from the beginning" + d + "days" + h + "hours" + m + "Minutes" + s + "Seconds";
        if (countDown === 0) {
          _this.showVideoBegin = true;
          clearInterval(_this.timer);
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.closeVideo();
  },
  computed: {},
  watch: {},
  filters: {},
};
</script>

<style lang="less" scoped>
.video {
  background-color: black;
  width: 100%;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
}

.pofBox {
  // position: absolute !important;
  top: 0;
  max-width: 1200px;
  z-index: 999;
}
.playBack,
.before,
.playbox,
.pofBox {
  width: 100%;
  height: 56.7vw;
  background-color: black;
  max-width: 768px;
  max-height: 436px;
  position: relative;
}
.txt {
  color: #fff;
  width: 100%;
  line-height: 42px;
  position: absolute;
  bottom: 0;
  // background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4));
  // // background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  // font-size: 18px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
}
.other {
  color: #fff;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  margin: auto;
  text-align: center;
  transform: translateY(-50%);
}
.videoBox {
  width: 100%;
  height: 100%;
}
.video_play_btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
.before_T {
  height: 52px;
  background: #efefef;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: right;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    display: flex;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #eaeaea;
    padding: 0 4px;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #222222;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    margin: 0 8px;
  }
}
</style>
<style>
@media (prefers-color-scheme: dark) {
  .before_T {
    background: #111111 !important;
    color: #ffffff !important;
  }
  .before_T span {
    background: #353535 !important;
    border: 1px solid #444444 !important;
    color: #ffffff !important;
  }
}
</style>